var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGemGold(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Gem_gold"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 1000001211"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.6746 5.16089L2.46875 7.7797L9.1031 5.16089H5.6746Z",
    fill: "#F62578"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M15.729 7.77312L12.5316 5.16089H5.6746L2.46875 7.7797L9.21161 10.6958L15.7272 7.78441C15.7282 7.78401 15.7292 7.78332 15.7299 7.78243C15.7307 7.78153 15.7312 7.78046 15.7314 7.77931C15.7315 7.77816 15.7314 7.77699 15.731 7.7759C15.7306 7.77481 15.7299 7.77385 15.729 7.77312Z",
    fill: "#F58811"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M9.1031 5.16089H5.6746L2.46875 7.7797L9.21068 10.6948L9.1031 5.16089Z",
    fill: "url(#paint0_linear_1334_4487)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M9.10233 15.036L12.4195 8.53318L10.8161 5.55032L9.10233 5.16089H9.1014L7.38762 5.55032L5.78516 8.53318L9.1014 15.036H9.10233Z",
    fill: "url(#paint1_linear_1334_4487)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    opacity: 0.6,
    d: "M5.78592 8.53315L7.38838 5.55029L5.55019 7.9283L2.46875 7.77967L9.10216 15.036L5.78592 8.53315Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M12.4203 8.53314H5.78592L2.46875 7.77966L9.1031 15.036L15.7281 7.78343L12.4203 8.53314Z",
    fill: "url(#paint2_linear_1334_4487)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M12.5301 5.16089L15.3383 7.86813L9.10156 15.036L15.6396 7.8004L12.5301 5.16089Z",
    fill: "url(#paint3_linear_1334_4487)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    opacity: 0.7,
    d: "M8.48852 13.8281L6.40055 10.4643C5.91223 10.1435 4.31445 9.49915 4.31445 9.49915L8.48852 13.8281Z",
    fill: "url(#paint4_linear_1334_4487)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M12.4195 8.5332H5.78516L6.1528 9.25564L9.10233 15.036L12.4195 8.5332Z",
    fill: "url(#paint5_linear_1334_4487)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M12.4199 8.5332H5.77148L11.0241 9.1785L9.10643 15.0182L12.4199 8.5332Z",
    fill: "url(#paint6_linear_1334_4487)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M10.8171 5.55029L12.4205 8.53315L10.8105 11.6891L13.2783 8.33749L10.8171 5.55029Z",
    fill: "#FFE4BD"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M10.8161 4.77148H7.38761L5.67383 5.16092L7.38761 5.55036H10.8161L12.5308 5.16092L10.8161 4.77148Z",
    fill: "#FFA348"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M10.8172 5.55036L12.5319 5.16092L10.8172 4.77148H9.28206C9.28206 4.77148 8.47662 5.06121 10.1633 5.55036H10.8172Z",
    fill: "url(#paint7_linear_1334_4487)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M7.00968 4.85706L5.67383 5.16089L7.38761 5.55033H9.45967C9.45967 5.55033 6.91052 5.39229 7.00968 4.85706Z",
    fill: "url(#paint8_linear_1334_4487)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    opacity: 0.3,
    d: "M12.4158 7.02722H5.78804L2.47461 7.77975L5.78804 8.53323H12.4196L15.7265 7.7807L12.4158 7.02722Z",
    fill: "url(#paint9_linear_1334_4487)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    opacity: 0.4,
    d: "M7.53516 10.8218L8.82517 12.1293L9.01975 14.1715L7.53516 10.8218Z",
    fill: "url(#paint10_linear_1334_4487)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    opacity: 0.4,
    d: "M10.4833 12.7765L13.4516 9.62341L9.61523 14.3531L10.4833 12.7765Z",
    fill: "url(#paint11_linear_1334_4487)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M15.3179 7.8633C14.3469 8.0646 13.3759 8.27907 12.418 8.53305C13.5265 8.32328 14.6313 8.07024 15.723 7.78052L15.3179 7.8633Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M12.2029 8.93487L11.9859 9.33653C11.8437 9.60462 11.7052 9.87365 11.5602 10.1427C11.4152 10.4117 11.2796 10.6826 11.1383 10.9526L10.722 11.7644L10.3095 12.5781C10.1739 12.8499 10.0363 13.1218 9.90164 13.3946C9.76693 13.6674 9.63222 13.9402 9.49845 14.2129L9.30013 14.624L9.20097 14.83L9.10742 15.036L9.21687 14.8357L9.32539 14.6353L9.54148 14.2336C9.68367 13.9646 9.8268 13.6956 9.96712 13.4266C10.1074 13.1575 10.2478 12.8866 10.389 12.6166L10.8053 11.8058L11.2178 10.9912C11.3544 10.7193 11.4919 10.4484 11.6257 10.1756C11.7595 9.90281 11.8961 9.63002 12.0289 9.35629L12.2272 8.94522L12.3245 8.74015L12.4227 8.5332L12.3123 8.73357L12.2029 8.93487Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M12.1681 8.02903C12.0821 7.86159 11.9941 7.69604 11.9062 7.53048C11.8183 7.36492 11.7266 7.2003 11.6349 7.03569C11.5432 6.87107 11.4478 6.70928 11.3543 6.54842C11.436 6.71774 11.5198 6.88581 11.6059 7.05262C11.692 7.22006 11.7799 7.38562 11.8678 7.55117C11.9558 7.71673 12.0474 7.88135 12.1391 8.04596C12.1756 8.11087 12.2373 8.25103 12.2869 8.34133C12.4263 8.59343 11.4366 8.51253 10.763 8.50689L9.93328 8.49842L9.10446 8.49278C8.5516 8.49278 7.99873 8.49278 7.44587 8.49278H6.4524C6.39062 8.49289 6.32988 8.47676 6.2762 8.44599C6.22252 8.41522 6.17777 8.37088 6.14639 8.31736C6.115 8.26384 6.09807 8.20301 6.09727 8.14088C6.09647 8.07876 6.11183 8.0175 6.14183 7.96318C6.58337 7.16362 7.37665 5.73286 7.37665 5.73286C7.40051 5.69015 7.43529 5.65463 7.4774 5.62998C7.51951 5.60534 7.56741 5.59247 7.61613 5.5927C7.82567 5.5927 8.03522 5.5927 8.24476 5.5927C8.53102 5.5927 8.81633 5.5927 9.10259 5.5927L9.53103 5.58706L9.95948 5.57859C10.2401 5.57295 10.531 5.56448 10.8164 5.55226C10.5357 5.53909 10.2448 5.53156 9.95948 5.52498L9.53103 5.51651H9.10259C8.81633 5.51651 8.53102 5.51651 8.24476 5.51181C7.95851 5.5071 7.69658 5.51181 7.42249 5.51181C7.40234 5.51199 7.38224 5.50978 7.36262 5.50522L6.96691 5.42056L6.5366 5.3265C6.39347 5.29734 6.24941 5.26817 6.10628 5.2409C5.96315 5.21362 5.81816 5.1854 5.67409 5.15906C5.81535 5.19762 5.95473 5.23525 6.0988 5.27194L6.5235 5.382L6.95007 5.48735C6.98985 5.49698 7.02692 5.5156 7.05847 5.54179C7.09003 5.56798 7.11524 5.60105 7.13219 5.63849C7.14914 5.67593 7.15738 5.71677 7.1563 5.75789C7.15522 5.79902 7.14484 5.83936 7.12594 5.87585L5.81628 8.41565C5.80544 8.43687 5.78787 8.45385 5.76636 8.4639C5.74484 8.47395 5.7206 8.4765 5.69748 8.47114L4.96314 8.30841L4.1315 8.1278L3.71616 8.03373L3.29987 7.94625C2.41118 7.73648 2.8733 7.51919 3.32045 7.18243C4.37192 6.39792 5.67409 5.16094 5.67409 5.16094L5.26716 5.48077L4.86117 5.80247C4.59176 6.01695 4.32047 6.23048 4.05105 6.44589L3.24374 7.09307L2.44859 7.73366C2.44206 7.73892 2.43668 7.74547 2.43279 7.75291C2.42889 7.76035 2.42656 7.76852 2.42595 7.77691C2.42533 7.78529 2.42644 7.79372 2.42921 7.80165C2.43198 7.80959 2.43635 7.81686 2.44205 7.82302L3.25778 8.72324L4.08567 9.63193L4.91543 10.5387L5.74706 11.4427C6.30148 12.046 6.8584 12.6471 7.41781 13.246L7.83316 13.6947L8.25412 14.1424C8.53476 14.4406 8.8154 14.7397 9.09604 15.0361C8.82569 14.7275 6.59834 11.9883 4.40373 9.75045C3.93599 9.26883 2.50847 7.82773 2.50847 7.82773C2.78069 7.8964 3.01455 7.91709 3.28771 7.98388L3.70025 8.08453L4.11373 8.1833L4.94162 8.3799C4.94162 8.3799 5.76764 8.58402 5.77512 8.61036C6.6789 10.8531 7.7921 13.0046 9.09978 15.0361L5.88832 8.70631C5.88198 8.69141 5.87958 8.67512 5.88134 8.65902C5.88311 8.64291 5.88898 8.62754 5.89839 8.61438C5.9078 8.60123 5.92043 8.59075 5.93505 8.58394C5.94968 8.57714 5.9658 8.57425 5.98186 8.57556C6.48421 8.59437 6.93791 8.57556 7.44119 8.57556C7.99406 8.57556 8.54692 8.57556 9.09978 8.57085L9.92861 8.56521L10.7584 8.55769C11.039 8.55769 11.3112 8.55016 11.5872 8.54546C11.8632 8.54075 12.1401 8.53699 12.417 8.53041C12.417 8.53323 12.2542 8.19835 12.1681 8.02903Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    d: "M11.6789 5.37639C11.8211 5.34346 11.9595 5.31054 12.1064 5.27385C12.2533 5.23717 12.3871 5.20048 12.5311 5.16003C12.3861 5.18355 12.2421 5.20989 12.098 5.23999C11.9539 5.27009 11.8117 5.30019 11.6686 5.33406C11.5255 5.36792 11.3833 5.40084 11.2411 5.43659C11.0989 5.47234 10.9605 5.50996 10.8164 5.55135C10.9614 5.52689 11.1055 5.50056 11.2486 5.47045C11.3917 5.44035 11.5358 5.40931 11.6789 5.37639Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    opacity: 0.7,
    d: "M5.9112 8.58109C5.89738 8.57824 5.88469 8.57138 5.87471 8.56135C5.86473 8.55131 5.85791 8.53855 5.85508 8.52465L5.81672 7.79187L5.77556 8.52465C5.77273 8.53855 5.76591 8.55131 5.75593 8.56135C5.74595 8.57138 5.73326 8.57824 5.71943 8.58109L5.13477 8.61966L5.71943 8.65728C5.73321 8.66024 5.74584 8.66714 5.7558 8.67716C5.76576 8.68717 5.77262 8.69987 5.77556 8.71372L5.81298 9.44744L5.85133 8.71372C5.85427 8.69987 5.86114 8.68717 5.8711 8.67716C5.88106 8.66714 5.89369 8.66024 5.90746 8.65728L6.49213 8.61966L5.9112 8.58109Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1334_4487",
    x1: 5.84018,
    y1: 10.6948,
    x2: 5.84018,
    y2: 5.16089,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF0D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#F9F6CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#F4FBC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#FDB14F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1334_4487",
    x1: 9.10233,
    y1: 5.16089,
    x2: 9.10233,
    y2: 15.036,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#FED297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#FCC34F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#F79720"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F58811"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1334_4487",
    x1: 9.18729,
    y1: 7.97344,
    x2: 11.8711,
    y2: 13.6973,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA216"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#F39411"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#D36F03"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#CC6600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1334_4487",
    x1: 9.10156,
    y1: 10.0984,
    x2: 15.6396,
    y2: 10.0984,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA216"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#F39412"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#D46F08"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#B94F00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1334_4487",
    x1: 4.31445,
    y1: 11.6636,
    x2: 8.48571,
    y2: 11.6636,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF0D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#F9F6CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#F4FBC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#FDB14F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1334_4487",
    x1: 9.10233,
    y1: 8.5332,
    x2: 9.10233,
    y2: 15.036,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA216"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#F19515"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#CB7114"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#903812"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#671210"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1334_4487",
    x1: 5.62368,
    y1: 8.79189,
    x2: 10.9321,
    y2: 11.8396,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA216"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#F39412"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#D46F08"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#B94F00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1334_4487",
    x1: 9.08935,
    y1: 5.16092,
    x2: 12.5319,
    y2: 5.16092,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#FDB14F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#F4FBC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#F9F6CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF0D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1334_4487",
    x1: 5.67383,
    y1: 5.20322,
    x2: 9.45967,
    y2: 5.20322,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#721A74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#7B2574"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#944473"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#BC7571"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#F2B86F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEC76F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1334_4487",
    x1: 4.13039,
    y1: 4.89473,
    x2: 14.0981,
    y2: 10.6179,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEC76F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#F6BB67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#C6783B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#A3471B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#8E2807"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#861D00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1334_4487",
    x1: 7.53516,
    y1: 12.4971,
    x2: 9.01975,
    y2: 12.4971,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD4DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#FFE1E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1334_4487",
    x1: 9.61523,
    y1: 11.9882,
    x2: 13.4516,
    y2: 11.9882,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD4DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#FFE1E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGemGold);
export default __webpack_public_path__ + "static/media/Gem_gold.a458fa98bc1c6f916cf5da488a967442.svg";
export { ForwardRef as ReactComponent };